<template>
    <div :class="gridSizeClass" class="grid gap-y-4 gap-x-6 xl:gap-x-8">
        <slot/>
    </div>
</template>

<script setup>
import {computed} from 'vue';

const props = defineProps({
    gridSize: {
        type: Number,
        default: 0,
    }
});

const sizes = [
    'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4', // Normal
    'grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3', // Large
    'grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2', // Largest
    'grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5', // Small
];

const gridSizeClass = computed(() => sizes[props.gridSize % sizes.length] ?? sizes[0]);

</script>
